// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1xOC6","ranges":"BmiRanges_ranges__o3rDq"};